module.exports = true;



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.5.6@core-js/library/modules/_library.js
// module id = 13
// module chunks = 0